const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/usz/eCheckin/sections/fields/EinweisungField.tsx';
import { generateMetaKatDropDownField } from 'App/components/eCheckin/generateMetaKatDropDownField';

export const EinweisungField = generateMetaKatDropDownField('b29b27d2-6a22-4689-99bf-db45bea4faec', 'EinweisungField');
